import { render, staticRenderFns } from "./CapturaDocumentosFotoVerso.vue?vue&type=template&id=18ac3673&scoped=true&"
import script from "./CapturaDocumentosFotoVerso.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentosFotoVerso.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentosFotoVerso.vue?vue&type=style&index=0&id=18ac3673&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ac3673",
  null
  
)

export default component.exports